import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  openItem: ['dashboard'],
  currentItem: 'home',
  openComponent: 'buttons',
  selectedID: null,
  drawerOpen: false,
  componentDrawerOpen: true,
  menuDashboard: {},
  error: null
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },
    activeID(state, action) {
      state.selectedID = action.payload;
    },
    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },
    currentItem(state, action) {
      state.currentItem = action.payload.currentItem;
    },
    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },
    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },
    getMenuSuccess(state, action) {
      state.menuDashboard = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload;
    }
  }
});

export const { activeItem, currentItem, activeComponent, openDrawer, openComponentDrawer, activeID, getMenuSuccess, hasError } =
  menuSlice.actions;

export default menuSlice.reducer;
